import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const DeletePopup = ({
    data = {},
    type = "website",
    closePopup,
    updateError,
    deleteWebsite,
    deleteUser,
    deleteSubscription,
    deletePayment,
    deleteTicket,
    deleteColdEmail
}) => {
    const {websiteId, userId, subId, paymentId, ticketId, emailId} = data;
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            if (type === "website") {
                const res = await apiInstance.delete(`/devadmin/website/${websiteId}`);
                deleteWebsite && deleteWebsite(websiteId, res.data.counts);
                closePopup();
                setLoading(false)
            } else if(type === 'user') {
                const res = await apiInstance.delete(`/devadmin/user/${userId}`);
                deleteUser && deleteUser(userId);
                closePopup();
                setLoading(false)
            } else if(type === 'subscription') {
                const res = await apiInstance.delete(`/devadmin/subscription/${subId}`);
                deleteSubscription && deleteSubscription(subId);
                closePopup();
                setLoading(false)
            } else if(type === 'payment') {
                const res = await apiInstance.delete(`/devadmin/payment/${paymentId}`);
                deletePayment && deletePayment(paymentId);
                closePopup();
                setLoading(false)
            } else if(type === 'ticket') {
                const res = await apiInstance.delete(`/devadmin/support-ticket/${ticketId}`);
                deleteTicket && deleteTicket(ticketId);
                closePopup();
                setLoading(false)
            } else if(type === 'coldEmail') {
                const res = await apiInstance.delete(`/devadmin/cold-email/${emailId}`);
                deleteColdEmail && deleteColdEmail(emailId);
                closePopup();
                setLoading(false)
            }
        } catch (error) {
            console.error(`Error deleting ${type}:`, error);
            updateError &&
                updateError(error.response?.data?.message || "Something went wrong");
            setLoading(false);
        }
    };

    const deleteTextMap = {
        website: "website",
        user: "user",
        subscription: "subscription",
        payment: "payment",
        ticket: "support ticket",
        coldEmail: "cold email"
    };

    return (
        <div className="mjwidev-pp">
            <h2>DELETE</h2>
            <p>
                Do you really want to delete this {deleteTextMap[type] || ""}?
            </p>
            <div className="mjwidev-bottom-row">
                <Button name="Delete" eventHandler={handleDelete} />
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
            </div>
        </div>
    );
};

export default DeletePopup;
